import "./../PrivacyTerms.css";

const PolicyAndPrivacy = () => {
  return (
    <div className="privacy container my-5 text-white">
      <h1 className="mb-4">Privacy Policy</h1>
      <p><strong>Last Updated:</strong> July 9, 2024</p>
      <p>
        Thank you for choosing <strong> Gamer Club</strong> provided by <strong>World Link</strong> in collaboration with Korek Telecom.
        This Privacy Policy explains how we collect, use, disclose, and protect your personal information in connection with the Service.
      </p>

      <hr />

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Personal Information:</strong> Your mobile number and other details required to provide the Service.</li>
        <li><strong>Usage Information:</strong> Data about how you interact with the Service, such as subscription start date, messages received, and cancellations.</li>
        <li><strong>Technical Information:</strong> Device type, network operator, and related details for service compatibility and troubleshooting.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To deliver and manage the Service.</li>
        <li>To process payments and manage your subscription.</li>
        <li>To send relevant updates, tips, or notifications as part of the Service.</li>
        <li>To improve and customize the Service.</li>
        <li>To comply with legal obligations and protect against fraudulent activities.</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <ul>
        <li><strong>Service Delivery:</strong> With authorized third parties or vendors who assist in providing the Service.</li>
        <li><strong>Legal Requirements:</strong> If required by law, regulation, or court order.</li>
        <li><strong>Business Operations:</strong> To address technical issues, resolve complaints, or protect the rights of Korek Telecom, the vendor, or subscribers.</li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>Your personal information will be stored only for as long as necessary to provide the Service or comply with legal obligations. Once no longer required, it will be securely deleted or anonymized.</p>

      <h2>5. Security of Your Information</h2>
      <p>We implement appropriate technical and organizational measures to protect your information against unauthorized access, loss, or misuse. However, no system can be guaranteed 100% secure.</p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>Access, correct, or update your personal information.</li>
        <li>Request the deletion of your data (subject to legal or operational obligations).</li>
        <li>Withdraw consent for data processing or stop using the Service at any time by unsubscribing.</li>
      </ul>
      <p>For inquiries regarding your data, please contact us via <strong>integration@worlinks.com</strong>.</p>

      <h2>7. Changes to the Privacy Policy</h2>
      <p>We may update this Privacy Policy periodically to reflect changes to the Service or legal requirements. Subscribers will be notified of significant updates through SMS or other communication channels.</p>

      <h2>8. Contact Us</h2>
      <p>If you have questions or concerns about this Privacy Policy, please contact:</p>
      <p>Email: <a href="mailto:integration@worlinks.com"> integration@worlinks.com </a> </p>

      <hr />

      <p className="mt-4">
        By subscribing to the Service, you acknowledge and agree to this Privacy Policy and the use of your personal information as outlined above.
      </p>
    </div>
  );
};

export default PolicyAndPrivacy;
